import React from "react";
import Xarrow from "react-xarrows";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { FlowConstants } from "../../../rule-engine-core/Flow/Utilities/FlowConstants";
import { FlowEditContext } from "../../FlowEditContext";
import { FlowStepOutputInstructionType } from "../../../rule-engine-core/Flow/Structure/FlowStepOutputInstructions";
import { FlowConfiguration } from "../../../rule-engine-core/Flow/FlowConfiguration";
import { FlowExtraConnection } from "../../../rule-engine-core/Flow/Structure/FlowExtraConnection";
import { FlowStepSequence } from "../../../rule-engine-core/Flow/Structure/FlowStepSequence";

interface IExtraConnection {
    connection: FlowExtraConnection;
    editContext: FlowEditContext;
}

export const ExtraConnection: React.FC<IExtraConnection> = (props: IExtraConnection) => {
    return (
        <ObserveState
            listenTo={props.connection.fromInstruction}
            properties={[FlowStepSequence.STRATEGY]}
            control={() => {
                return (
                    <Xarrow
                        key={props.connection.fromId}
                        start={props.connection.fromId}
                        end={props.connection.toId}
                        startAnchor={[
                            {
                                position: "bottom",
                                offset: {
                                    x: 5,
                                },
                            },
                        ]}
                        endAnchor={"top"}
                        strokeWidth={2}
                        headSize={3}
                        color={
                            props.connection.fromInstruction.strategy === FlowStepOutputInstructionType.END_FLOW
                                ? FlowConstants.END_LINE_COLOR
                                : FlowConstants.ERROR_LINE_COLOR
                        }
                        _debug={false}
                        divContainerStyle={{ zIndex: 3 }}
                        path={"smooth"}
                    />
                );
            }}
        />
    );
};

interface IFlowEditorExtraConnections {
    editContext: FlowEditContext;
    flow: FlowConfiguration;
}

export const FlowEditorExtraConnections: React.FC<IFlowEditorExtraConnections> = (
    props: IFlowEditorExtraConnections,
) => {
    const renderEndLines = () => (
        <ObserveState
            listenTo={props.flow.endSequence}
            properties={[FlowStepSequence.IS_COLLAPSED]}
            control={() => {
                return props.editContext.getEndFlowConnections().map((c: FlowExtraConnection) => (
                    <ExtraConnection
                        connection={c}
                        key={c.fromId}
                        editContext={props.editContext}
                    />
                ));
            }}
        />
    );

    const renderErrorLines = () => (
        <ObserveState
            listenTo={props.flow.endSequence}
            properties={[FlowStepSequence.IS_COLLAPSED]}
            control={() => {
                return props.editContext.getErrorFlowConnections().map((c: FlowExtraConnection) => (
                    <ExtraConnection
                        connection={c}
                        key={c.fromId}
                        editContext={props.editContext}
                    />
                ));
            }}
        />
    );

    return (
        <ObserveState
            listenTo={props.editContext}
            properties={[FlowEditContext.SHOW_ERROR_OR_END_CONNECTIONS, FlowEditContext.IS_SHOW_ERROR_BRANCH]}
            control={() => (
                <>
                    {renderEndLines()}
                    {renderErrorLines()}
                </>
            )}
        />
    );
};
